import React from 'react'
import { cn } from '~shared/utils/cn'

type Props = {
  className?: string
  size: 'lg' | 'sm'
}

export const Shevron: React.FC<Props> = ({ className, size }) => {
  const params = {
    width: { lg: 9, sm: 6 },
    height: { lg: 15, sm: 10 },
    viewBox: { lg: '0 0 9 15', sm: '0 0 6 10' },
    path: {
      lg: (
        <path
          d='M8.07129 7.88328C8.07129 7.68453 7.99972 7.50953 7.84863 7.35848L1.54269 1.19569C1.40751 1.05251 1.23258 0.980922 1.02582 0.980922C0.612297 0.980922 0.29425 1.2911 0.29425 1.70462C0.29425 1.91131 0.381719 2.08631 0.508951 2.22149L6.29799 7.88328L0.50895 13.5451C0.381717 13.6803 0.294249 13.8632 0.294249 14.062C0.294249 14.4755 0.612296 14.7856 1.02582 14.7856C1.23258 14.7856 1.40751 14.7141 1.54269 14.5789L7.84863 8.40813C7.99972 8.26499 8.07129 8.0821 8.07129 7.88328Z'
          fill='currentColor'
        />
      ),
      sm: (
        <path
          d='M5.99219 5.43395C5.99219 5.29766 5.94311 5.17765 5.83951 5.07408L1.51544 0.848167C1.42274 0.749987 1.30279 0.700898 1.16101 0.700898C0.87745 0.700898 0.659361 0.913589 0.659361 1.19715C0.659361 1.33888 0.719339 1.45888 0.806584 1.55157L4.77621 5.43395L0.806583 9.31636C0.719339 9.40905 0.65936 9.53446 0.65936 9.67078C0.65936 9.95433 0.877449 10.167 1.16101 10.167C1.30279 10.167 1.42274 10.1179 1.51544 10.0252L5.83951 5.79384C5.94311 5.69569 5.99219 5.57028 5.99219 5.43395Z'
          fill='currentColor'
        />
      )
    }
  }

  return (
    <svg
      width={params.width[size]}
      height={params.height[size]}
      viewBox={params.viewBox[size]}
      className={className}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      {params.path[size]}
    </svg>
  )
}
